import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import Cookies from 'js-cookie';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import { clearCookie, setCookie, getUserDetails, isLogin } from '../../functions/Auth';
import { useHistory } from 'react-router-dom';
import API_PATH from "../../constants/config.json";
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Start css code ..
const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '98%',
    },
  },
  rootBox: {
    flexGrow: 1,
  },
  paper: {
    width: '100%',
    boxShadow: 'none',
  },
  signMain: {
    position: 'fixed',    
    background: 'transparent',
    height: 'auto',    
    right: '0px',    
    // overflowY: 'scroll',
    '@media only screen and (max-width: 3500px)': {
      width: '500px', 
      bottom: '5px',     
    },
    '@media only screen and (min-width: 3501px)': {
      width: '800px', 
      bottom: '10px',     
    },
  },
  myProfileContainer:{    
    float: 'right', 
    background: '#fff',
    borderRadius: '5px',
    padding: '0px', 
    border: '1px solid #24618E', 
    borderRadius: '5px',
    height: '86.8vh', 
    '@media only screen and (max-height: 820px)': {
      height: '83vh'
    },
    '@media only screen and (max-width: 1500px)': {
      width: '500px',
    },
    '@media only screen and (min-width: 1501px) and (max-width: 3500px)': {
      width: '500px'
    },
    '@media only screen and (min-width: 3501px)': {
      width: '800px',
      maxWidth:'800px',
      '& input':{
        fontSize:'22pt',
      }
    },
  },
  signInBtn: {
    border: '1px solid rgba(36, 97, 142, 1)',
    color: '#fff',
    background: 'rgba(36, 97, 142, 1)!important',
    fontSize: '12px',
    width: '140px',
  },
  cancelBtn: {
    border: '1px solid #333',
    color: '#333',
    background: '#fff!important',
    fontSize: '12px',
    width: '140px',
  },
  rootForm: {    
    '& input#email': {
      padding: '10px',
    },
    '& input#first_name': {
      padding: '10px',
    },
    '& input#last_name': {
      padding: '10px',
    },
    '& input#password': {
      padding: '10px',
    },
    '& input#organization': {
      padding: '10px',
    },
    '& input#confirm_password': {
      padding: '10px',
    },
    '& h4': {
      margin: '0px',
      '@media only screen and (min-width: 3501px)': {
        fontSize: '24pt',
      },
    },
    '& ul': {
      marginTop: '5px',
      paddingLeft: '25px',
    },
    '& input[type="password"]': {
      padding: '10px',
    }
  },
  formInput: {
    width: '100%',
  },
  formHead: {
    padding: '15px 15px 0px 15px',
    '& h3': {
      color: '#24618E',      
      marginTop: '0px',
      marginBottom: '-10px',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '25px',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '26pt',
      },
    },
    '& img': {
      width: '100%',
      height: '2px',
    }
  },
  OtherLink: {
    width: '80%',
    margin: '0 auto',
    '& a': {
      color: '#24618E',
    }
  },
  teamsUl: {
    paddingLeft: '5px !important',
    '& li': {
      listStyle: 'none',
    }
  },
  btnIcon: {
    color: '#24618E',
    marginRight: '5px',
    cursor: 'pointer',
  },
  fieldsetname: {
    width: 'auto',
    border: '1px solid rgba(0, 167, 93, 1)',
    margin: '10px',
    padding: '10px',    
    borderRadius: '5px',
    '@media only screen and (min-width: 3501px)': {
      marginTop:'20px !important'
    }
  },
  errMsgPassword: {
    '& span': {
      fontSize: '11pt !important'
    }
  },
  closeIcon:{
    textAlign: 'right',     
     right: '10px', margin: '0',
     position: 'absolute', 
      top: '10px', 
     '@media only screen and (max-width: 3500px)': {
      fontSize: '25px',
      width: '40px',  
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '40px',
      width: '50px',
    },
  },
  innerPanel:{
    overflowY: 'scroll',    
    paddingBottom: '10px', 
    position: 'relative',
    background: '#fff', 
    marginRight: '10px', 
    height: '76.8vh', 
    '@media only screen and (min-width: 3501px)': {
      '& button':{
        marginTop:'10px',
        marginBottom:'10px',
      }
    },
    '@media only screen and (max-height: 820px)': {
      height: '73vh'
    },
  }
}));
//End css code ..


//Start MyProfile component code ..
const MyProfile = props => {
  let history = useHistory();
  const [spacing, setSpacing] = React.useState(2);
  const [passwordValues, setPasswordValues] = React.useState({
    currentpwd: "",
    newpwd: "",
    cnfNewPwd: ""
  });
  const [errPopUp, setErrPopUp] = React.useState(false);
  const [errMsg, setErrMsg] = React.useState(null);
  const [errMsgType, setErrMsgType] = React.useState('error');
  const classes = useStyles();
  const myRef = useRef(null);
  const [currentPassword, setCurrentPassword] = React.useState('');
  const [newPassword, setNewPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [assignedTeams, setAssignedTeams] = React.useState([]);
  const [showTeams, setShowTeams] = React.useState([]);
  const [userDetails, setUserDetails] = React.useState([]);

  const [firstName, setFirstName] = React.useState(Cookies.get('firstName'));
  const [lastName, setLastName] = React.useState(Cookies.get('lastName'));
  const [organization, setOrganization] = React.useState(Cookies.get('organization'));

  const [initialFirstName, setInitialFirstName] = React.useState(Cookies.get('firstName'));
  const [initialLastName, setInitialLastName] = React.useState(Cookies.get('lastName'));
  const [initialOrganization, setInitialOrganization] = React.useState(Cookies.get('organization'));

  const [profileErr, setProfileErr] = React.useState(false);
  const [passwordErr, setPasswordErr] = React.useState(false);

  const handleChange = (event) => {
    setSpacing(Number(event.target.value));
  };
  useEffect(
    () => {
      getTeamsAssigned();
    }, [])

  const ShowErrPopUP = () => {
    setErrPopUp(false)
  };

  const profileHandleChange = name => event => {
    if (name == 'first_name') {
      setFirstName(event.target.value);
    } else if (name == 'last_name') {
      setLastName(event.target.value)
    } else if (name == 'organization') {
      setOrganization(event.target.value);
    }
  }

  //This code use for update user profile .... start
  const updateMyProfile = async () => { 
    setProfileErr(false);
    setPasswordErr(false);
    if (userDetails && userDetails.user_id) {
      let data = { "userId": userDetails.user_id, 'email':Cookies.get('email'), 'first_name': firstName, 'last_name': lastName, 'organization': organization }
      try {
        axios({
          method: 'post',
          data: data,
          headers: {
            'payload': Cookies.get('payload'),
            'agencyid': sessionStorage.getItem('agency_id')
          },
          url: API_URL + API_PATH.updateMyProfileAPI,         
        })
          .then(async function (response) {
            if (response.status && response.status == '200') {
              await setCookie('firstName', response.data.data.first_name);
              await setCookie('lastName', response.data.data.last_name);
              await setCookie('organization', response.data.data.organization);
              setInitialFirstName(response.data.data.first_name);
              setInitialLastName(response.data.data.last_name);
              setInitialOrganization(response.data.data.organization);
              setErrMsgType('success');
              setErrMsg('Your profile has been updated.');
              setErrPopUp(true);
            } else {
              setErrMsgType('error')
              setErrMsg('Something went wrong.');
              setErrPopUp(true);
              setProfileErr(true);
            }
          })
          .catch(async function (error) {
            if (error.response) {
              if (error.response.status == '401') {
                if (Cookies.get('email')) {
                  clearCookie('email');
                  clearCookie('payload');
                  clearCookie('idToken');
                  clearCookie('atexpiry');
                }
                history.push('/');
              } else {
                setErrMsgType('error')
                setErrMsg(error.response.data.message);
                setErrPopUp(true);
                setProfileErr(true);
              }             
            } else {
              setErrMsgType('error')
              setErrMsg('Something went wrong.');
              setErrPopUp(true);              
              setProfileErr(true);
            }
          })
      } catch (error) {
        console.error(error);
      }
    } else {
      if (Cookies.get('email')) {
        clearCookie('email');
        clearCookie('payload');
        clearCookie('idToken');
        clearCookie('atexpiry');
      }
      history.push('/');
    }
  }
  //This code use for update user profile .... end

  //This code is use for myprofile form validations ....start
  const updateMyProfileValidation = (e) => {
    setProfileErr(false);
    setPasswordErr(false);
    e.preventDefault();
    if (firstName == '') {
      setErrMsgType('error')
      setErrMsg('Firstname required');
      setErrPopUp(true)
      setProfileErr(true);
    } else if (lastName == '') {
      setErrMsgType('error')
      setErrMsg('Lastname required');
      setErrPopUp(true)
      setProfileErr(true);
    } else {
      updateMyProfile();
    }
  }
  //This code is use for myprofile form validations ....end

  const passwordHandleChange = name => event => {
    if (name == 'currentpwd') {
      setCurrentPassword(event.target.value);
    } else if (name == 'newpwd') {
      setNewPassword(event.target.value);
    } else if (name == 'cnfNewPwd') {
      setConfirmPassword(event.target.value);
    }
    setPasswordValues({ ...passwordValues, [name]: event.target.value });
  }

  const clearPasswordForm = () => {
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
  }
  

  //This code use for change password form validations ... start
  const passwordValidateForm = async e => {
    setProfileErr(false);
    setPasswordErr(false);
    setErrMsgType('error')
    let passwordCheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$.!%*?&]{8,}$/
    setErrMsg(null);
    e.preventDefault();
    if (passwordValues.currentpwd == '') {
      setErrMsg('Current Password required.');
      setErrPopUp(true);
      setPasswordErr(true)
    } else if (passwordValues.newpwd == '') {
      setErrMsg('New Password required.');
      setErrPopUp(true)
      setPasswordErr(true)
    } else if (!passwordCheck.test(passwordValues.newpwd)) {
      setErrMsgType('error');
      setErrMsg('Password does not meet the criterion.');
      setErrPopUp(true)
      setPasswordErr(true)
    } else if ((Cookies.get('firstName') && (passwordValues.newpwd).toLowerCase().includes(Cookies.get('firstName').toLowerCase())) && ((Cookies.get('lastName') && passwordValues.newpwd).toLowerCase().includes(Cookies.get('lastName').toLowerCase()))) {
      setErrMsgType('error')
      setErrMsg('Password must not contain your name.');
      setErrPopUp(true);
      setPasswordErr(true)
    } else if (Cookies.get('email') && passwordValues.newpwd.includes(Cookies.get('email'))) {
      setErrMsgType('error');
      setErrMsg('Password must not contain your email.');
      setErrPopUp(true);
      setPasswordErr(true)
    } else if (passwordValues.cnfNewPwd == '') {
      setErrMsg('Confirm Password required.');
      setErrPopUp(true)
      setPasswordErr(true)
    } else if (passwordValues.newpwd !== passwordValues.cnfNewPwd) {
      setErrMsgType('error');
      setErrMsg('The provided passwords do not match');
      setErrPopUp(true);
      setPasswordErr(true)
    } else {
      changePassword();
    }
  }
  //This code use for change password form validations ... end


  //This code is use for change password API call ... start
  const changePassword = async () => { 
    setProfileErr(false);
    setPasswordErr(false);
    if (isLogin()) {
      try {
        axios({
          method: 'post',
          data: { ...passwordValues },
          url: API_URL + API_PATH.changePasswordAPI,
        })
          .then(async function (response) {
            if (response.status && response.status == '200') {
              myRef.current.scrollTo(0, 0);
              setErrMsgType('success');
              setErrMsg('Your password has been updated.');
              setErrPopUp(true);
              setCurrentPassword('');
              setNewPassword('');
              setConfirmPassword('');
              setPasswordValues(
                {
                  currentpwd: "",
                  newpwd: "",
                  cnfNewPwd: ""
                }
              )
            } else {
              setErrMsgType('error')
              setErrMsg('Something went wrong.');
              setErrPopUp(true)
              setPasswordErr(true)
            }
          })
          .catch(async function (error) {
            if (error.response) {
              if (error.response.status == '401') {
                if (Cookies.get('email')) {
                  clearCookie('email');
                  clearCookie('payload');
                  clearCookie('idToken');
                  clearCookie('atexpiry');
                  clearCookie('alLogIn');
                }
                history.push('/');
              } else {
                setErrMsgType('error')
                setErrMsg(error.response.data.message.message);
                setErrPopUp(true)
                setPasswordErr(true)
              }
            } else {
              setErrMsgType('error')
              setErrMsg('Something went wrong.');
              setErrPopUp(true)
              setPasswordErr(true)
            }
          })
      } catch (error) {
        console.error(error);
      }
    } else {
      if (Cookies.get('email')) {
        clearCookie('email');
        clearCookie('payload');
        clearCookie('idToken');
        clearCookie('atexpiry');
        clearCookie('alLogIn');
      }
      history.push('/');
    }
  }
  //This code is use for change password API call ... end


  //This method is use for get user details ... start
  const getTeamsAssigned = async () => {
    let details = await getUserDetails(); 
    setUserDetails(details)
    try {
      axios({
        method: 'post',
        data: { 'userId': details.user_id },
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        url: API_URL + API_PATH.getAssignedTeamAPI,
      })
        .then(function (response) {
          setAssignedTeams(response.data.data);
        })
        .catch(function (error) {
          setAssignedTeams([]);
        })
    } catch (error) {
      console.error(error);
    }
  }
  //This method is use for get user details ... end

  const expandTeams = () => {
    if (showTeams == false) {
      setShowTeams(true);
    } else {
      setShowTeams(false);
    }
  }

  const clearProfileForm = () => {
    setFirstName(initialFirstName);
    setLastName(initialLastName);
    setOrganization(initialOrganization);
  }

  return (
    <React.Fragment>
      <CssBaseline />
      <div className={classes.signMain} >
        <Container maxWidth="sm" className={classes.myProfileContainer}>
          <div className={classes.formHead}><h3>My Profile</h3>
            <p onClick={props.checkValue} className={classes.closeIcon}><FontAwesomeIcon icon={faTimes} className={classes.btnIcon} /></p>
            <img src={require('../../assets/images/hrimg.svg')} /></div>
          <Typography component="div" className={classes.innerPanel} ref={myRef}>
            {errMsg && errMsgType == 'success' ? <div className={classes.errMsgPassword}><ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> </div> : null}
            <form className={classes.rootForm} noValidate autoComplete="off" data-testid='profile_form' onSubmit={e => updateMyProfileValidation(e)}>
              <fieldset className={classes.fieldsetname}>
                <legend>Details</legend>
                {profileErr ? <div className={classes.errMsgPassword} style={{ marginBottom: '10px' }}><ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> </div> : null}
                <Grid container className={classes.rootBox} spacing={spacing}>
                  <Grid item xs={12}>
                    <Grid container justify="center" spacing={spacing}>
                      <Grid xs={6} item>
                        <Paper className={classes.paper} >
                          <TextField id="first_name" data-testid="first_name" className={classes.formInput} placeholder="First Name *" type="text" variant="outlined" value={firstName} required onChange={profileHandleChange('first_name')} />
                        </Paper>
                      </Grid>
                      <Grid xs={6} item>
                        <Paper className={classes.paper} >
                          <TextField id="last_name" data-testid="last_name" className={classes.formInput} placeholder="Last Name *" type="text" variant="outlined" required value={lastName} onChange={profileHandleChange('last_name')} />
                        </Paper>
                      </Grid>
                      <Grid xs={12} item>
                        <Paper className={classes.paper} >
                          <TextField id="email" data-testid="email" className={classes.formInput} placeholder="Email *" type="email" variant="outlined" value={Cookies.get('email') ? Cookies.get('email') : ''} required />
                        </Paper>
                      </Grid>
                      <Grid xs={12} item>
                        <Paper className={classes.paper} >
                          <TextField id="organization" data-testid="organization" className={classes.formInput} placeholder="Organization" type="text" variant="outlined" value={organization} onChange={profileHandleChange('organization')} />
                        </Paper>
                      </Grid>
                      <Grid xs={12} item>
                        <Paper className={classes.paper} style={{ textAlign: 'center' }} >
                          <Button type="reset" variant="outlined" id="cancel_btn" data-testid="profile_cancel_btn" className={classes.cancelBtn} onClick={() => { clearProfileForm() }}>
                            Cancel</Button>&nbsp;&nbsp;
                          <Button type="submit" variant="outlined" id="save_btn" data-testid="profile_save_btn" className={classes.signInBtn}>
                            Save</Button>
                        </Paper>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </fieldset>
            </form>
            <form className={classes.rootForm} noValidate autoComplete="off">
              <fieldset className={classes.fieldsetname}>
                <legend>My Teams</legend>
                <Grid container className={classes.rootBox} spacing={spacing}>
                  <Grid item xs={12}>
                    <Grid container justify="center" spacing={spacing}>
                      <Grid xs={12} item>
                        <Paper className={classes.paper} >
                          <ul className={classes.teamsUl}>
                            <li><FontAwesomeIcon icon={showTeams == false ? faPlus : faMinus} className={classes.btnIcon} onClick={() => expandTeams()} />{userDetails ? userDetails.agencyname : null}</li>
                            {showTeams == true ?
                              assignedTeams && assignedTeams.length > 0 ? assignedTeams.map((value, index) => {
                                return <li style={{ paddingLeft: '25px' }} key={index}>{value.team_name}</li>
                              }) : <li style={{ paddingLeft: '25px' }}>{'No teams assigned.'}</li>
                              : null
                            }
                          </ul>
                        </Paper>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </fieldset>
            </form>
            <form className={classes.rootForm} noValidate autoComplete="off" onSubmit={e => passwordValidateForm(e)} data-testid='change_pwd_form'>
              <fieldset className={classes.fieldsetname}>
                <legend>Change My Password</legend>
                <Grid container className={classes.rootBox} spacing={spacing}>
                  <Grid item xs={12}>
                    <Grid container justify="center" spacing={spacing}>
                      <Grid xs={12} item>
                        <Paper className={classes.paper} >
                          <h4>Password should:</h4>
                          <ul>
                            <li>be at least 8 characters long</li>
                            <li>contain at least 1 number, 1 upper-case letter, and 1 lower-case letter</li>
                            <li>contain at least 1 special character</li>
                            <li>not contain your name or email address</li>
                          </ul>
                        </Paper>
                      </Grid>
                      {passwordErr ? <div className={classes.errMsgPassword}><ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> </div> : null}
                      <Grid xs={12} item>
                        <Paper className={classes.paper} >
                          <TextField id="current_password" data-testid="current_password" className={classes.formInput} placeholder="Current Password *" type="password" variant="outlined" onChange={passwordHandleChange('currentpwd')} required value={currentPassword} />
                        </Paper>
                      </Grid>
                      <Grid xs={12} item>
                        <Paper className={classes.paper} >
                          <TextField id="new_password" data-testid="new_password" className={classes.formInput} placeholder="New Password *" type="password" variant="outlined" onChange={passwordHandleChange('newpwd')} required value={newPassword} />
                        </Paper>
                      </Grid>
                      <Grid xs={12} item>
                        <Paper className={classes.paper} >
                          <TextField id="confirm_new_password" data-testid="confirm_new_password" className={classes.formInput} placeholder="Confirm New Password *" type="password" variant="outlined" onChange={passwordHandleChange('cnfNewPwd')} required value={confirmPassword} />
                        </Paper>
                      </Grid>
                      <Grid xs={12} item>
                        <Paper className={classes.paper} style={{ textAlign: 'center' }} >
                          <Button type="reset" variant="outlined" id="cancel_btn1" data-testid="cancel_pwd_btn" className={classes.cancelBtn} onClick={() => { clearPasswordForm() }}>
                            Cancel</Button>&nbsp;&nbsp;
                          <Button type="submit" variant="outlined" id="save_btn1" data-testid="save_pwd_btn" className={classes.signInBtn}>
                            Save</Button>
                        </Paper>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </fieldset>
            </form>
            {/* <div className={classes.OtherLink}>   
    <p style={{ marginBottom:'5px'}}><NavLink  to="/forgot_password">Forgot your password?</NavLink></p>
    <p style={{ marginTop:'5px'}}><NavLink  to="/sign_in">Sign In</NavLink></p>
    </div> */}
          </Typography>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default MyProfile;
//End MyProfile component code ..